import React, { Component } from 'react';
import cookie from '../../src/cookiecut.png';
import { Button } from '@blueprintjs/core';
import{withRouter,Link} from 'react-router-dom';
import { observer , inject } from 'mobx-react';



@withRouter
@inject("store")
@observer

export default class EnvironmentModel extends Component
{
    back(){
        this.props.store.storymodel = "nothing";
       
        this.forceUpdate();
        this.props.history.push("/storymodel")
    }

    environment(){
        this.props.store.environmentmodel = "nothing";
        this.forceUpdate();
    }

    ghost(){
        this.props.store.environmentmodel = "ghost";
        this.forceUpdate();
    }

    match(){
        this.props.store.environmentmodel = "match";
        this.forceUpdate();
    }

    kingdom(){
        this.props.store.environmentmodel = "kingdom";
        this.forceUpdate();
    }

    foreign(){
        this.props.store.environmentmodel = "foreign";
        this.forceUpdate();
    }

    crowd(){
        this.props.store.environmentmodel = "crowd";
        this.forceUpdate();
    }


   

    
    render()
    {
        return <>
        
        {this.props.store.environmentmodel == "nothing" &&  <div className = "modeltext">
        欢迎来到环境模版~<br/><br/>
        从小故事指南中，大家应该也能意识到<br/>
        好的环境能激发冲突，让故事更加精彩<br/><br/>

        为了便于理解<br/>
        这里提供五个环境模版以供参考<br/>
        
        
        
       <br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.ghost() } >鬼屋</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.match() } >比武台</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.kingdom() } >独裁王国</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.foreign() } >异国他乡</Button><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.crowd() } >乌合之众</Button><br/>

<div className = "buttonbox">
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.back() } >返回模版</Button><br/>
    </div>   
    </div> }


    {this.props.store.environmentmodel == "ghost" &&  <div className = "modeltext">
        鬼屋，顾名思义，就是一个可怕的鬼屋<br/>
        首先它是个密闭空间，人物很难或无法逃出去<br/>
        其次，里面有一种大家无法应对，可能也无法理解的超自然力量，可能伤害所有人<br/>
        最后，这个超自然力量有它的逻辑和规则。虽然主角可能不理解，但它并不是没有道理的。如果毫无道理，没有方式方法的伤害人，就是非常烂的鬼片了<br/>
        如果你跑过团，很多克苏鲁剧本都是设置在鬼屋之中的。<br/>
        这种环境天然有冲突和悬疑，对故事有很大的影响<br/>
        如果感兴趣，可以试着写写看<br/><br/>
        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.environment() } >返回环境模版</Button><br/>

        </div>}


        {this.props.store.environmentmodel == "match" &&  <div className = "modeltext">
            比武台，又叫比赛台，或者运动场。<br/>
            它是一个拥有比赛规则，获胜奖励和比赛选手的环境<br/>
            比如在饥饿游戏中，24名选手必须杀死其他选手才能活下来<br/>
            就是一个非常典型的比武台<br/><br/>
            规则越清晰，简单易懂，环境的设置越有力<br/>
            比如饥饿游戏中的“谁最后活下来谁赢”，就比“用不同方式杀死对手记不同的分数，最后统分来排名决定输赢”，要更简洁有力<br/>
            奖励越大，环境中的冲突越激烈<br/>
            比如饥饿游戏中获胜才能活下来，并有巨额奖金。<br/>
            比赛选手越强，冲突也会越激烈<br/><br/>
            这是个很常见的，用于激化冲突的环境。<br/>
            也天然拥有悬疑因素，虽然不如鬼屋的悬疑强，但依然是强悬疑的环境<br/>
            大家有兴趣可以写写看<br/><br/>
            <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.environment() } >返回环境模版</Button><br/>
            </div>}

            {this.props.store.environmentmodel == "kingdom" &&  <div className = "modeltext">
                独裁王国，是一个拥有极端权力的环境<br/>
                极端的权力带来极端的权力斗争。<br/>
                权力斗争没有规则，不择手段，胜者为王，因而相比比武台更加混乱和残忍<br/>
                而且，没有规则也就意味着结局是开放的<br/>
                有可能主角与其他人都是赢家，或者谁也没有赢。因而比比武台更丰富更多元<br/>
                像甄嬛传和纸牌屋，都设置在这样的环境中<br/><br/>
                依旧是一个强冲突强悬疑的环境<br/>
                大家有兴趣可以写写看<br/><br/>
                <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.environment() } >返回环境模版</Button><br/>

                </div>}

                {this.props.store.environmentmodel == "foreign" &&  <div className = "modeltext">
                    异国他乡，是一个具有异国情调与特色的环境<br/>
                    可能对主角来说是异国他乡，或者对于主角与观众来说都是异国他乡<br/>
                    这个环境的重点在营造特殊的氛围，以及主角适应环境的过程<br/>
                    陌生的地方，发生的事情都是新鲜的<br/>
                    异国他乡这个环境的重点，就在于新鲜，以及意外<br/>
                    如《阿凡达》与《碟中谍5：神秘国度》都发生在非常有特点的异国他乡<br/>
                    <br/>
                    这样的环境设置，对故事情节没有太大影响。<br/>
                    只是用于增加特色，大家有兴趣可以写写看<br/><br/>
                    <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.environment() } >返回环境模版</Button><br/>
                    </div>}

                    {this.props.store.environmentmodel == "crowd" &&  <div className = "modeltext">
                        乌合之众，是一个社会环境，也就是一个群体<br/>
                        在这样的环境中，人们遵循某种规则，日复一日的做着某些事<br/>
                        但问题在于，主角很可能觉得他们是错的，或者有明显缺点的<br/>
                        主角通常会反抗这样的社会环境，并且受到攻击<br/><br/>
                        这是个天然有冲突的环境，但并不是强冲突。<br/>
                        冲突的强弱与主角的性格强弱和选择有关系<br/>
                        是可以依照自己的喜好去设置的，大家有兴趣可以写写看<br/><br/>
                        <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.environment() } >返回环境模版</Button><br/>
                        </div>}
   
        </>;
    }
} 